module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5r4r8n7n-1641e1cbd38f3a079f0cca9f4c241ab9.svg";